"use client";

import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { ColletteButton } from "@collette-travel/collette-common-controls";
import { useTranslations } from "next-intl";

interface TourHeaderButtonsProps {
  handleOpenRequestAQuote: () => void;
  variant?: "default" | "bottom-drawer";
  testId: string;
}

const TourHeaderButtons = ({
  handleOpenRequestAQuote,
  variant = "default",
  testId
}: TourHeaderButtonsProps) => {
  const t = useTranslations("PDP");

  const [datesAndPricingElement, setDatesAndPricingElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const el = document.getElementById("dates-and-pricing-section");
    setDatesAndPricingElement(el);
  }, []);

  const scrollToDatesAndPricing = () => {
    if (datesAndPricingElement) {
      const elementPosition =
        datesAndPricingElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 180;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <Stack
      sx={{
        flexDirection: { xs: "column", sm: "row" },
        ...(variant === "bottom-drawer" && {
          flexDirection: "row"
        }),
        gap: "1.2rem",
        alignItems: "center",
        justifyContent: { xs: "center", lg: "end" },
        width: { xs: "100%", lg: "auto" }
      }}
    >
      {datesAndPricingElement && ( // hide button if D&P section is missing
        <ColletteButton
          label={t("View Dates & Pricing")}
          onClick={scrollToDatesAndPricing}
          testId={`dates_pricing_button_${testId}`}
          variant="outlined"
          size="large"
          sx={{
            textWrap: "nowrap"
          }}
        />
      )}
      <ColletteButton
        color="primary"
        size="large"
        label={t("Request a Quote")}
        onClick={handleOpenRequestAQuote}
        testId={`request-quote-button_${testId}`}
        sx={{
          textWrap: "nowrap",
          ...(variant === "bottom-drawer" && {
            display: { xs: "none", sm: "inline" }
          })
        }}
      />
      {variant === "bottom-drawer" && (
        <ColletteButton
          color="primary"
          size="large"
          label={t("Get a Quote")}
          onClick={handleOpenRequestAQuote}
          testId={`get-quote-button_${testId}`}
          sx={{
            textWrap: "nowrap",
            display: { xs: "inline", sm: "none" }
          }}
        />
      )}
    </Stack>
  );
};

export default TourHeaderButtons;
